import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class ActivationService {
  private readonly gUrl = environment.appBackendUrl + '/';

  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Access-Control-Allow-Headers': 'Content-Type',
    })
  };

  constructor(private http?: HttpClient) { }

  public liatAssayActivation(requestData: any): Observable<any> {
    const url = `${this.gUrl}v1/liatAssayActivation`;
    return this.http.post<any>(url, requestData);
  }

  public liatSoftwareActivation(requestData: any): Observable<any> {
    const url = `${this.gUrl}v1/liatSoftwareActivation`;
    return this.http.post<any>(url, requestData, this.httpOptions);
  }
}
